import React from 'react';

const MODES = [
  ['all', 'All'],
  ['mine', 'Owned'],
  ['others', 'Others'],
];

export default function FiltersPanel({filterMode, setFilterMode, resources, isMine, hideInactive, setHideInactive}) {
  const inMode = (resources || []).filter(r => {
    if (filterMode === 'mine') return isMine(r);
    if (filterMode === 'others') return !isMine(r);
    return true;
  });
  const hiddenCount = hideInactive
    ? inMode.filter(r => r.is_active === false).length
    : 0;
  const shownCount = inMode.length - hiddenCount;

  return (
    <div className="p-6">
      <div className="flex items-start gap-2.5 mb-4">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Filters</h3>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2 bg-surface dark:bg-gray-870 p-1 rounded-md">
          {MODES.map(([mode, label]) => (
            <button
              key={mode}
              type="button"
              onClick={() => setFilterMode(mode)}
              aria-pressed={filterMode === mode}
              className={`flex-1 text-sm py-2 rounded-md transition ${
                filterMode === mode
                  ? 'border border-brand-500 bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300'
                  : 'border border-gray-200/70 dark:border-gray-600/70 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="text-sm text-gray-700 dark:text-gray-300">
          <div className="font-medium">{shownCount} {shownCount === 1 ? 'resource' : 'resources'}</div>
          {filterMode !== 'all' && (
            <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Showing {filterMode === 'mine' ? 'owned' : 'others'} resources
            </div>
          )}
        </div>

        <label className="flex items-start gap-2.5 pt-1 cursor-pointer">
          <input
            type="checkbox"
            checked={!!hideInactive}
            onChange={(e) => setHideInactive(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-870"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Hide deactivated
            <span className="mt-0.5 block text-xs text-gray-500 dark:text-gray-400">
              {hiddenCount > 0
                ? `${hiddenCount} deactivated ${hiddenCount === 1 ? 'resource' : 'resources'} hidden`
                : 'Retired markets stay out of the list'}
            </span>
          </span>
        </label>
      </div>
    </div>
  );
}
